const createEvent = (() => {
  // Standard:
  if (typeof Event === 'function') {
    return (eventName, eventInit) => new Event(eventName, eventInit);
  }

  // IE11 support:
  return (eventName) => {
    const event = document.createEvent('Event');
    event.initEvent(eventName, true, true);

    return event;
  };
})();


export default createEvent;



// WEBPACK FOOTER //
// ./src/utils/domEvents/createEvent.js